/* ===========================================================================
   Clara Román · theme behaviour
   ---------------------------------------------------------------------------
   Same restraint as the static prototype: opacity over 0.3 to 0.5s plus one
   word-by-word headline. What changed for Shopify is that the cart, the
   search and the quick buy are real now, talking to the Ajax API instead of
   to a local array.
   ========================================================================= */

(function () {
  "use strict";

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var R  = window.claraRoutes || {};
  var S  = window.claraStrings || {};

  /* --------------------------------------- masked top-level navigation -- */

  $$("#mega > .mi > a, #mega > .mi--flat").forEach(function (a) {
    if ($(".nav-shift", a)) return;
    var label = a.textContent.trim();
    a.textContent = "";
    var shell = document.createElement("span");
    shell.className = "nav-shift";
    var first = document.createElement("span");
    var second = document.createElement("span");
    first.textContent = label;
    second.textContent = label;
    second.setAttribute("aria-hidden", "true");
    shell.appendChild(first);
    shell.appendChild(second);
    a.appendChild(shell);
  });

  function money(cents) {
    var f = window.claraMoneyFormat || "{{amount}}";
    var v = (cents / 100).toFixed(2).replace(".", ",");
    return f.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* --------------------------------------------- word by word headline -- */

  function renderWords(h, text) {
    var words = text.trim().split(/\s+/);
    h.textContent = "";
    h.classList.remove("is-lit");
    words.forEach(function (w, i) {
      var span = document.createElement("span");
      span.className = "w";
      span.style.setProperty("--i", i);
      var inner = document.createElement("i");
      inner.textContent = w;
      span.appendChild(inner);
      h.appendChild(span);
      if (i < words.length - 1) h.appendChild(document.createTextNode(" "));
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { h.classList.add("is-lit"); });
    });
  }

  $$("[data-words]").forEach(function (h) {
    h.dataset.src = h.textContent.trim();
    var below = h.getBoundingClientRect().top > innerHeight * 0.9;
    renderWords(h, h.dataset.src);
    if (below && !reduce && "IntersectionObserver" in window) {
      h.classList.remove("is-lit");
      new IntersectionObserver(function (es, o) {
        if (es[0].isIntersecting) { h.classList.add("is-lit"); o.disconnect(); }
      }, { threshold: 0.3 }).observe(h);
    }
  });

  /* ------------------------------------------------ header over the hero -- */

  var hdr = $("#hdr");
  var hero = $(".hero__media");

  if (hdr && hdr.dataset.transparent === "true" && hero && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      hdr.classList.toggle("hdr--over", es[0].intersectionRatio > 0.12);
    }, { threshold: [0, 0.12, 0.3] }).observe(hero);
  } else if (hdr) {
    hdr.classList.remove("hdr--over");
  }

  /* ------------------------------------------------- the animation layer -- */

  $$("[data-marquee]").forEach(function (t) { t.innerHTML = t.innerHTML + t.innerHTML; });

  // With «Títulos palabra a palabra» on, clara-anim.js splits these headings
  // into words instead of masking the whole line.
  var wordTitles = document.body.classList.contains("anim-titles");

  $$(".sec__head .dsp, .camp .dsp").forEach(function (h) {
    if (h.hasAttribute("data-words") || wordTitles) return;
    var inner = document.createElement("span");
    inner.className = "mk__i";
    while (h.firstChild) inner.appendChild(h.firstChild);
    var mask = document.createElement("span");
    mask.className = "mk";
    mask.appendChild(inner);
    h.appendChild(mask);
  });

  // Only inside a node carrying .rise: the wipe is released by an ancestor,
  // never by the clipped node itself. A fully clipped element reports zero
  // intersection area, so observing it directly deadlocks.
  $$(".panel img:not(.panel__fill), .ella video, .ella img").forEach(function (im) {
    im.classList.add("rv");
  });

  ["#grid", ".ellas", ".panels"].forEach(function (sel) {
    var box = $(sel);
    if (!box) return;
    $$(".rise", box).forEach(function (el, i) {
      if (!el.style.getPropertyValue("--d")) el.style.setProperty("--d", (i % 4) * 85);
    });
  });

  var animated = $$(".rise, .mk");
  if (reduce || !("IntersectionObserver" in window)) {
    animated.forEach(function (el) { el.classList.add("is-in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    animated.forEach(function (el) { io.observe(el); });
  }

  $$(".hero__media img").forEach(function (im) {
    im.classList.add("kb");
    if (reduce || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (es, o) {
      if (es[0].isIntersecting) { im.classList.add("is-on"); o.disconnect(); }
    }, { threshold: 0.2 }).observe(im);
  });

  /* -------------------------------------------------- card carousels ---- */

  function initCarousels(root) {
    $$("[data-carousel]", root).forEach(function (m) {
      if (m.dataset.ready) return;
      m.dataset.ready = "1";
      var slides = $$(".card__slide", m);
      var fills  = $$(".card__fill", m);
      if (slides.length < 2) { m.setAttribute("data-nav", ""); if (slides[0]) slides[0].setAttribute("data-on", ""); if (fills[0]) fills[0].setAttribute("data-on", ""); return; }
      var dots = $$(".card__dots i", m);
      var i = 0;

      function show(n) {
        i = (n + slides.length) % slides.length;
        m.setAttribute("data-nav", "");
        slides.forEach(function (s, k) { k === i ? s.setAttribute("data-on", "") : s.removeAttribute("data-on"); });
        fills.forEach(function (s, k) { k === i ? s.setAttribute("data-on", "") : s.removeAttribute("data-on"); });
        dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
      }

      var prev = $(".card__arw--prev", m), next = $(".card__arw--next", m);
      if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); show(i - 1); });
      if (next) next.addEventListener("click", function (e) { e.preventDefault(); show(i + 1); });
    });
  }
  initCarousels(document);

  /* ------------------------------------------------------------- tabs --- */

  function initTabs(root) {
    $$('[data-collection-section]', root).forEach(function (section) {
      if (section.dataset.tabsReady) return;
      section.dataset.tabsReady = 'true';
      var tabs = $$('.tab', section), cards = $$('.card', section);
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (other) { other.setAttribute('aria-selected', String(other === tab)); });
          cards.forEach(function (card) { card.hidden = tab.dataset.filter !== 'todo' && card.dataset.cat !== tab.dataset.filter; });
        });
        tab.addEventListener('keydown', function (event) {
          var direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (direction) { event.preventDefault(); tabs[(i + direction + tabs.length) % tabs.length].focus(); }
        });
      });
    });
  }
  initTabs(document);

  /* --------------------------------------------------------- mega nav --- */

  $$("[data-mi]").forEach(function (mi) {
    var trigger = $("a", mi);
    function open(v) {
      v ? mi.setAttribute("data-open", "") : mi.removeAttribute("data-open");
      trigger.setAttribute("aria-expanded", String(v));
    }
    trigger.addEventListener("focus", function () { open(true); });
    mi.addEventListener("focusout", function (e) { if (!mi.contains(e.relatedTarget)) open(false); });
    mi.addEventListener("keydown", function (e) { if (e.key === "Escape") { open(false); trigger.focus(); } });
    mi.addEventListener("mouseleave", function () { open(false); });
  });

  /* ---------------------------------------------------------- overlays -- */

  // The cart (right) and the mobile menu (left, as a side panel when
  // «Cesta y menú laterales» is on) share one open/close routine: focus goes
  // into the panel, Tab stays inside it, Esc or the scrim closes it and focus
  // returns to whatever opened it. Closing runs shorter than opening.
  var body = document.body;
  function on(c) { return body.classList.contains(c); }
  var sidePanels = on("anim-drawers");

  var scrim = $("#scrim");
  var drw = $("#drw"), cartBtn = $("#cartbtn"), drwClose = $("#drw-close");
  var cartN = $("#cart-n"), drwBody = $("#drw-body"), drwSub = $("#drw-sub");
  var burger = $("#burger"), mnav = $("#mnav"), mclose = $("#mclose");
  var openPanel = null, returnTo = null;

  // The header section is its own stacking layer, so a side panel left inside
  // it would sit under the scrim. As a side panel the menu lives in <body>.
  function lift(nav) {
    if (!sidePanels || !nav || nav.parentNode === body) return nav;
    $$("body > #mnav").forEach(function (old) { if (old !== nav) old.remove(); });
    body.appendChild(nav);
    return nav;
  }
  mnav = lift(mnav);

  function lock(v) { document.body.style.overflow = v ? "hidden" : ""; }
  function outMs(panel) {
    if (sidePanels) return reduce ? 200 : 250;
    if (reduce) return 0;
    return panel === mnav ? 380 : 340;
  }
  function showScrim(v) {
    if (!scrim) return;
    clearTimeout(scrim._t);
    if (v) {
      scrim.hidden = false;
      void scrim.offsetWidth;
      scrim.classList.add("is-open");
    } else {
      scrim.classList.remove("is-open");
      scrim._t = setTimeout(function () { scrim.hidden = true; }, sidePanels ? outMs() : (reduce ? 0 : 280));
    }
  }

  function modal(panel) {
    if (!panel) return;
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
  }

  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter(function (x) { return x.offsetParent !== null; });
  }

  // Items inside the panel arrive one after another, just after the panel.
  function stagger(panel) {
    if (!sidePanels) return;
    var items = panel === drw
      ? $$(".drw2__ship, .drw2__li, .drw2__empty, .drw2__foot, .cl__i, .drw__foot", panel)
      : $$("ul > li, .mnav__utils", panel);
    items.forEach(function (el, k) {
      el.setAttribute("data-st", "");
      el.style.setProperty("--i", Math.min(k, 7));
    });
  }

  function openPanelEl(panel, opener) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) closePanel(openPanel, true);
    clearTimeout(panel._t);
    panel.hidden = false;
    panel.style.transform = "";
    stagger(panel);
    void panel.offsetWidth;
    panel.classList.add("is-open");
    if (panel === drw || sidePanels) showScrim(true);
    lock(true);
    openPanel = panel;
    returnTo = opener || document.activeElement;
    var btn = panel === drw ? cartBtn : burger;
    if (btn) btn.setAttribute("aria-expanded", "true");
    var first = panel === drw ? drwClose : mclose;
    if (first) first.focus({ preventScroll: true });
  }

  function closePanel(panel, silent) {
    if (!panel || panel.hidden) return;
    panel.classList.remove("is-open");
    panel.style.transform = "";
    if (panel === drw || sidePanels) showScrim(false);
    lock(false);
    clearTimeout(panel._t);
    panel._t = setTimeout(function () { panel.hidden = true; }, outMs(panel));
    if (openPanel === panel) openPanel = null;
    var btn = panel === drw ? cartBtn : burger;
    if (btn) btn.setAttribute("aria-expanded", "false");
    if (silent) return;
    var back = returnTo && document.contains(returnTo) && !returnTo.disabled ? returnTo : btn;
    if (back) back.focus({ preventScroll: true });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab" || !openPanel) return;
    var f = focusables(openPanel);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!openPanel.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });

  // Touch only: drag the open panel back out the way it came to close it.
  function swipe(panel, dir) {
    if (!panel || panel._swipe) return;
    panel._swipe = true;
    var x0 = 0, y0 = 0, t0 = 0, dx = 0, drag = false, pid = null;
    panel.addEventListener("pointerdown", function (e) {
      if (!sidePanels || reduce || e.pointerType === "mouse" || !panel.classList.contains("is-open")) return;
      if (e.target.closest("input, textarea, select")) return;
      x0 = e.clientX; y0 = e.clientY; t0 = performance.now(); dx = 0; drag = false; pid = e.pointerId;
    });
    panel.addEventListener("pointermove", function (e) {
      if (pid !== e.pointerId) return;
      var mx = e.clientX - x0, my = e.clientY - y0;
      if (!drag) {
        if (Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my) * 1.2) {
          drag = true;
          panel.classList.add("is-drag");
          try { panel.setPointerCapture(pid); } catch (err) {}
        } else if (Math.abs(my) > 10) { pid = null; return; }
        else return;
      }
      dx = mx * dir;
      var d = dx > 0 ? dx : dx * 0.2;
      panel.style.transform = "translateX(" + (d * dir) + "px)";
      if (scrim) scrim.style.opacity = String(Math.max(0, 1 - Math.max(0, dx) / panel.offsetWidth));
    });
    function end(e) {
      if (pid !== e.pointerId) return;
      pid = null;
      if (!drag) return;
      drag = false;
      panel.classList.remove("is-drag");
      if (scrim) scrim.style.opacity = "";
      var v = Math.abs(dx) / Math.max(1, performance.now() - t0);
      if (dx > panel.offsetWidth * 0.25 || (dx > 24 && v > 0.11)) closePanel(panel);
      else panel.style.transform = "";
    }
    panel.addEventListener("pointerup", end);
    panel.addEventListener("pointercancel", end);
  }

  modal(drw);
  modal(mnav);
  swipe(drw, 1);
  swipe(mnav, -1);

  /* ----------------------------------------------------- cart (real) ---- */

  function openDrawer(v, opener) {
    if (!drw) return;
    if (v) openPanelEl(drw, opener || cartBtn);
    else closePanel(drw);
  }

  // Re-render the drawer from the section rendering API so the markup stays
  // in Liquid rather than being rebuilt by hand in JS.
  function refreshCart() {
    return fetch(R.cart + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartN) cartN.textContent = cart.item_count;
        if (drwSub) drwSub.textContent = money(cart.total_price);
        return fetch(R.cart + "?view=lines")
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (drwBody) drwBody.innerHTML = html;
            var cta = $(".drw__cta");
            if (cta) cta.disabled = cart.item_count === 0;
          })
          .catch(function () {});
      });
  }

  // Screen readers hear «Añadido» without the focus moving.
  var live = document.createElement("div");
  live.className = "sr";
  live.setAttribute("role", "status");
  live.setAttribute("aria-live", "polite");
  body.appendChild(live);
  function announce(msg) {
    live.textContent = "";
    setTimeout(function () { live.textContent = msg; }, 60);
  }

  // The button stays locked while the request runs: a spinner in place of
  // the label, then «✓ Añadido» for a moment, then back to its label.
  function addToCart(id, btn) {
    var fancy = !!btn && on("anim-atc");
    var label = btn ? btn.textContent : "";
    var added = S.added || "Añadido";
    if (btn) {
      clearTimeout(btn._t);
      btn.classList.remove("is-ok", "is-back");
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      if (fancy) {
        btn.style.setProperty("--spin", getComputedStyle(btn).color);
        btn.classList.add("is-load");
      } else {
        btn.textContent = "...";
      }
    }
    function restore() {
      if (!btn) return;
      btn.removeAttribute("aria-busy");
      btn.classList.remove("is-load");
      btn.textContent = label;
      btn.disabled = false;
    }
    return fetch(R.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { restore(); alert(res.j.description || res.j.message || "No se pudo añadir."); return; }
        announce(added);
        if (fancy) {
          var okText = btn.classList.contains("qb__s") ? "✓" : "✓ " + added;
          btn.removeAttribute("aria-busy");
          btn.classList.remove("is-load");
          btn.textContent = okText;
          btn.classList.add("is-ok");
          btn._t = setTimeout(function () {
            btn.classList.remove("is-ok");
            // The size picker may have rewritten the label meanwhile; then it owns the button.
            if (btn.textContent !== okText) return;
            btn.textContent = label;
            btn.disabled = false;
            btn.classList.add("is-back");
            btn._t = setTimeout(function () { btn.classList.remove("is-back"); }, 260);
          }, 1600);
        } else {
          restore();
        }
        return refreshCart().then(function () { openDrawer(true, btn); });
      })
      .catch(function () { restore(); });
  }

  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add]");
    if (add && !add.disabled) { e.preventDefault(); addToCart(add.getAttribute("data-add"), add); return; }

    var qty = e.target.closest("[data-qty]");
    if (qty) {
      e.preventDefault();
      fetch(R.cart_change, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: qty.getAttribute("data-qty"), quantity: Number(qty.getAttribute("data-to")) })
      }).then(refreshCart);
    }
  });

  function toggleCart() { openDrawer(!drw.classList.contains("is-open")); }

  if (cartBtn) {
    cartBtn.addEventListener("click", toggleCart);
    if (drwClose) drwClose.addEventListener("click", function () { openDrawer(false); });
  }
  if (scrim) scrim.addEventListener("click", function () { if (openPanel) closePanel(openPanel); });

  /* --------------------------------------------------- search (real) ---- */

  var srch = $("#srch"), q = $("#q"), res = $("#srch-res");
  var searchBtn = $("#searchbtn"), srchClose = $("#srch-close");

  function openSearch(on) {
    if (!srch) return;
    if (on) {
      srch.hidden = false;
      requestAnimationFrame(function () { srch.classList.add("is-open"); });
      q.focus();
    } else {
      srch.classList.remove("is-open");
      setTimeout(function () { srch.hidden = true; }, reduce ? 0 : 320);
      if (searchBtn) searchBtn.focus();
    }
    if (searchBtn) searchBtn.setAttribute("aria-expanded", String(on));
  }

  if (searchBtn) {
    searchBtn.addEventListener("click", function () { openSearch(srch.hidden); });
    if (srchClose) srchClose.addEventListener("click", function () { openSearch(false); });

    var timer;
    q.addEventListener("input", function () {
      clearTimeout(timer);
      var v = q.value.trim();
      if (v.length < 2) { res.innerHTML = ""; return; }
      timer = setTimeout(function () {
        var url = R.predictive + "?q=" + encodeURIComponent(v) +
                  "&resources[type]=product&resources[limit]=6&section_id=predictive-search";
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) { res.innerHTML = html; })
          .catch(function () { res.innerHTML = ""; });
      }, 220);
    });
  }

  /* ------------------------------------------------------ mobile menu --- */

  function setNav(open) {
    if (!mnav) return;
    if (open) openPanelEl(mnav, burger);
    else closePanel(mnav);
  }
  function toggleNav() { setNav(!mnav.classList.contains("is-open")); }
  function bindNav() {
    if (!burger || !mnav || burger._bound) return;
    burger._bound = true;
    burger.addEventListener("click", toggleNav);
    if (mclose) mclose.addEventListener("click", function () { setNav(false); });
    mnav.addEventListener("click", function (e) { if (e.target.closest("a")) setNav(false); });
  }
  bindNav();

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (openPanel) closePanel(openPanel);
    else if (srch && !srch.hidden) openSearch(false);
  });

  /* ---------------------------------------------- clips play in view ---- */

  var clips = $$(".ella video");
  if (clips.length && "IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === "none") v.preload = "auto";
          var pl = v.play();
          if (pl && pl.catch) pl.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    clips.forEach(function (v) { vio.observe(v); });
  }

  // Theme editor re-renders sections without reloading the page.
  document.addEventListener("shopify:section:load", function (e) {
    initCarousels(e.target);
    initTabs(e.target);
    $$('[data-words]', e.target).forEach(function (h) { renderWords(h, h.textContent); });
    $$('.ella video', e.target).forEach(function (v) { if (vio) vio.observe(v); });
    // These controls are bound to the global header and must be rebound after its replacement.
    hdr = $('#hdr'); cartBtn = $('#cartbtn'); cartN = $('#cart-n'); searchBtn = $('#searchbtn');
    burger = $('#burger'); mnav = $('#mnav'); mclose = $('#mclose');
    if (e.target.contains(hdr)) {
      if (cartBtn) cartBtn.addEventListener('click', toggleCart);
      if (searchBtn) searchBtn.addEventListener('click', function () { openSearch(srch.hidden); });
      mnav = lift(mnav);
      modal(mnav);
      swipe(mnav, -1);
      bindNav();
    }
    $$(".rise, .mk", e.target).forEach(function (el) { el.classList.add("is-in"); });
  });
})();
